export const getRole = () => sessionStorage.getItem("adminRole") || "";
export const isSuperAdmin = () => getRole() === "super-admin";
// Super admin has every admin permission
export const isAdmin = () => getRole() === "admin" || isSuperAdmin();
// Image/video downloads are restricted to the super admin login
export const canDownloadMedia = () => isSuperAdmin();

export const getAdminId = () => {
  const token = sessionStorage.getItem("adminToken");
  if (!token) return "";
  try {
    return JSON.parse(atob(token.split(".")[1])).id || "";
  } catch {
    return "";
  }
};
